<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
#app {
  height: 100%;
}
.el-menu {
  border-right: none;
  background-color: transparent;
}
.el-menu--vertical > .el-menu {
  background-color: #ffffff;
  .el-menu-item {
    color: #303133 !important;
  }
}
.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: transparent;
}
.el-submenu__title:hover {
  background-color: transparent;
}
.el-menu-item-group__title {
  background-color: transparent;
  font-size: 14px;
}
.el-scrollbar__wrap {
  overflow-y: hidden;
  overflow-x: hidden;
  margin-bottom: 0!important;
   margin-right: 0 !important;
}
.el-dropdown-menu {
  width: 300px;
  box-sizing: border-box;
  padding: 0px 15px 10px 15px;
  .more_action {
    width: 100%;
    padding: 15px 0px 5px 0px;
    box-sizing: border-box;
    .user_icon {
      width: 52px;
      height: 52px;
      display: flex;
      border-radius: 100px;
      overflow: hidden;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      img {
        width: 48px;
        height: 48px;
      }
    }
    .user_news {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .user_name {
        font-size: 14px;
        color: #999999;
      }
      .user_phone {
        font-size: 14px;
        color: #303133;
      }
    }
    .more_operate {
      width: 95%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
	  padding: 0 10px;
      .more_item {
        width: 100%;
        height: 46px;
        border-top: 1px solid #eeeeee;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .icon_img {
          margin-right: 8px;
        }
      }
      .more_item:last-child {
        border-bottom: 1px solid #eeeeee;
      }
      .more_item:hover {
        background-color: #f5f5f5;
      }
    }
  }
}
.el-tabs__header {
  margin-bottom: 0px;
}
.bus_msg {
  list-style: none;
  padding: 0px;
  margin: 0px;
  width: 100%;
  .bus_msg_item {
    height: 50px;
    width: 100%;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    .bus_msg_title {
      color: #666666;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .bus_msg_time {
      color: #999999;
      font-size: 14px;
    }
  }
  .bus_msg_item:last-child {
    border-bottom: none;
  }
}
.el-select-dropdown .el-scrollbar .el-scrollbar__wrap {
  // overflow: scroll !important;
  overflow: hidden auto !important;
}

.el-main .el-scrollbar .el-scrollbar__wrap {
  overflow:hidden auto !important;
}
.el-table .cell{
  padding: 0!important;
}
.el-table .el-table__cell .cell .el-button{
  margin-right: 10px!important;
  margin-left: 0!important;
}
.el-table{
  width:99%!important;
}
.el-main{
	overflow: hidden!important;
}
// .el-scrollbar__wrap{
//   overflow:hidden auto !important;
// }
.el-cascader-node{
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue